import { createFileRoute } from '@tanstack/react-router';
import PageTitle from 'src/components/creator/PageTitle';
import ContactForm from 'src/components/ContactForm';

const SupportPage = () => {
  return (
    <>
      <PageTitle title="Contact Us" />
      <div className="bg-surface-alt rounded-xl shadow-3 p-6 mt-4 min-h-0 overflow-y-auto">
        <ContactForm />
      </div>
    </>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_creator/creator-support'
)({
  component: SupportPage,
});
